<template>
  <div class="bankForm">
    <!-- <base-form
      v-model="baseData"
      :options="baseDataOptions"
      ref="baseData"
      :rules="rules"
      :disabled="!canEdit"
      @input="handleChangeBaseData"
      label-width="105px"
    ></base-form> -->
    <div class="business-statement">
      <el-form
        class="form"
        :model="baseData"
        label-width="120px"
        :rules="rules"
        :disabled="!canEdit"
        ref="baseData"
      >
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item :label="$t('bankAccountEdit.bankForm.company')" prop="companyCode">
              <el-select
                required
                clearable
                v-model="baseData.companyCode"
                filterable
                @change="handleChangeBaseData(baseData, 'companyCode')"
              >
                <el-option
                  v-for="item in companyOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="银行代码" prop="bankCode">
              <bankSearchModel
                searchType="bank"
                :isMultiple="true"
                :currentValue="baseData.bankCode"
                @input="(val) => chooseTable(val)"
              ></bankSearchModel>
            </el-form-item>
          </el-col>
          <!-- 银行名称 -->
          <el-col :span="6">
            <el-form-item :label="$t('bankAccountEdit.bankForm.bankName')" prop="bankName">
              <el-input
                v-model="baseData.bankName"
                disabled
                required
                autocomplete="off"
                :placeholder="$t('bankAccountEdit.bankForm.bankNamePlaceholder')"
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- 银行国家 -->
          <el-col :span="6">
            <el-form-item :label="$t('bankAccountEdit.bankForm.bankNational')" prop="bankNational">
              <el-input
                v-model="baseData.bankNational"
                disabled
                autocomplete="off"
                :placeholder="$t('bankAccountEdit.bankForm.bankNationalPlaceholder')"
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- 分行 -->
          <el-col :span="6">
            <el-form-item :label="$t('bankAccountEdit.bankForm.branch')" prop="branchName">
              <el-input
                v-model="baseData.branchName"
                disabled
                autocomplete="off"
                :placeholder="$t('bankAccountEdit.bankForm.branchPlaceholder')"
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- 银行联行号 -->
          <el-col :span="6">
            <el-form-item :label="$t('bankAccountEdit.bankForm.branchCode')" prop="branchCode">
              <el-input
                v-model="baseData.branchCode"
                disabled
                required
                autocomplete="off"
                :placeholder="$t('bankAccountEdit.bankForm.branchCodePlaceholder')"
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- 银行组 -->
          <el-col :span="6">
            <el-form-item :label="$t('bankAccountEdit.bankForm.bankGroup')" prop="bankGroup">
              <el-input
                v-model="baseData.bankGroup"
                disabled
                autocomplete="off"
                :placeholder="$t('bankAccountEdit.bankForm.bankGroupPlaceholder')"
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- SWIFT码 -->
          <el-col :span="6">
            <el-form-item :label="$t('bankAccountEdit.bankForm.swiftCode')" prop="swiftCode">
              <el-input
                v-model="baseData.swiftCode"
                disabled
                autocomplete="off"
                :placeholder="$t('bankAccountEdit.bankForm.swiftCodePlaceholder')"
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- sap银行编码 -->
          <el-col :span="6">
            <el-form-item :label="$t('bankAccountEdit.bankForm.sapBankCode')" prop="sapBankCode">
              <el-input
                v-model="baseData.sapBankCode"
                required
                autocomplete="off"
                :placeholder="$t('bankAccountEdit.bankForm.sapBankCodePlaceholder')"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<script>
  // import baseForm from '@/components/form/base-form';
  import { mapState } from 'vuex';
  import bankSearchModel from '../../../masterData/components/bankSearchModel/bankSearchModel.vue';
  // import DataBaseAPI from '@/api/dataBase';

  export default {
    name: 'bankForm',
    components: {
      // baseForm,
      bankSearchModel,
    },
    props: ['canEdit'],
    data() {
      return {
        baseData: {
          id: null,
          companyCode: null,
          companyName: null,
          bankCode: null,
          bankName: null,
          bankNational: null,
          branchName: null,
          branchCode: null,
          bankGroup: null,
          swiftCode: null,
          sapBankCode: null,
        },
        bankOptions: [],
        bankBranchOptions: [],
        companyOptions: [],
        bankDisabled: true,
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      //基础数据表单配置
      baseDataOptions() {
        return [
          {
            // 公司
            type: 'select',
            label: this.$t('bankAccountEdit.bankForm.company'),
            prop: 'companyCode',
            options: this.companyOptions,
            placeholder: this.$t('bankAccountEdit.bankForm.companyPlaceholder'),
            disabled: false,
            clearable: true,
            required: true,
            filterable: true,
          },
          {
            // 银行代码
            type: 'searchTable',
            prop: 'bankCode',
            searchType: 'bank',
            isMultiple: true,
            label: this.$t('bankAccountEdit.bankForm.bankCode'),
            required: true,
            propName: 'bankCode',
            name: 'bankCode',
            getName: 'bankCode',
            currentValue: this.baseData.bankCode,
          },
          {
            // 银行名称
            type: 'input',
            label: this.$t('bankAccountEdit.bankForm.bankName'),
            prop: 'bankName',
            placeholder: this.$t('bankAccountEdit.bankForm.bankNamePlaceholder'),
            disabled: true,
            required: true,
          },
          {
            // 银行国家
            type: 'input',
            label: this.$t('bankAccountEdit.bankForm.bankNational'),
            prop: 'bankNational',
            placeholder: this.$t('bankAccountEdit.bankForm.bankNationalPlaceholder'),
            disabled: true,
          },
          {
            // 分行
            type: 'input',
            label: this.$t('bankAccountEdit.bankForm.branch'),
            prop: 'branchName',
            placeholder: this.$t('bankAccountEdit.bankForm.branchPlaceholder'),
            disabled: true,
            required: true,
          },
          {
            // 银行联行号
            type: 'input',
            label: this.$t('bankAccountEdit.bankForm.branchCode'),
            prop: 'branchCode',
            placeholder: this.$t('bankAccountEdit.bankForm.branchCodePlaceholder'),
            disabled: true,
            required: true,
          },
          {
            // 银行组
            type: 'input',
            label: this.$t('bankAccountEdit.bankForm.bankGroup'),
            prop: 'bankGroup',
            placeholder: this.$t('bankAccountEdit.bankForm.bankGroupPlaceholder'),
            disabled: true,
          },
          {
            // SWIFT码
            type: 'input',
            label: this.$t('bankAccountEdit.bankForm.swiftCode'),
            prop: 'swiftCode',
            placeholder: this.$t('bankAccountEdit.bankForm.swiftCodePlaceholder'),
            disabled: true,
          },
          {
            //sap银行编码
            type: 'input',
            label: this.$t('bankAccountEdit.bankForm.sapBankCode'),
            prop: 'sapBankCode',
            placeholder: this.$t('bankAccountEdit.bankForm.sapBankCodePlaceholder'),
            required: true,
          },
        ];
      },
      rules() {
        return {
          companyCode: [{ required: true, message: '请选择' }],
          bankCode: [{ required: true, message: '请输入' }],
          bankName: [{ required: true, message: '请输入' }],
          branchName: [{ required: true, message: '请输入' }],
          branchCode: [{ required: true, message: '请输入' }],
          sapBankCode: [{ required: true, message: '请输入' }],
        };
      },
    },

    mounted() {
      this.getCompany();
    },
    methods: {
      // 选择弹窗数据
      chooseTable(val) {
        console.log(val, 'val');
        this.baseData.bankName = val[0].bankName || '-';
        this.baseData.bankCode = val[0].bankCode || '-';
        this.baseData.bankNational = val[0].bankNational || '-';
        this.baseData.branchName = val[0].branchName || '-';
        this.baseData.branchCode = val[0].branchCode || '-';
        this.baseData.bankGroup = val[0].bankGroup || '-';
        this.baseData.swiftCode = val[0].swiftCode || '-';
      },
      //基本数据表单变化
      handleChangeBaseData(value, prop) {
        console.log(value, prop);
        if (prop == 'companyCode') {
          this.baseData.companyName = this.companyOptions.find(
            (it) => it.value == value.companyCode
          ).label;
        }
        if (prop == 'bankCode') {
          this.bankChange(value.bankCode);
        }
      },
      async getCompany() {
        // 公司
        let res = await this.$baseRequest.getCompanyList();
        if (res) {
          this.companyOptions = res;
        }
      },
      bankChange(val) {
        let names = [
          'bankCode',
          'bankName',
          'branchCode',
          'branchName',
          'bankNational',
          'bankGroup',
          'swiftCode',
        ];
        if (val && val.length > 0) {
          names.map((item) => {
            return (this.baseData[item] = val[0][item]);
          });
        } else {
          names.map((item) => {
            return (this.baseData[item] = null);
          });
        }
      },
      // 返回数据
      exportChildData(btnType) {
        if (btnType == '001' || btnType == '002') {
          // 点击提交，走校验
          let sign = false;
          this.$refs.baseData.validate((valid) => {
            if (valid) {
              sign = true;
            } else {
              sign = false;
            }
          });
          return sign ? this.baseData : false;
        } else {
          return this.baseData;
        }
      },
    },
  };
</script>
<style lang="scss" scoped></style>
